export function isIconTypeCustom(icon?: string): boolean {
    return icon?.startsWith('data:image') || false;
}
